import { render, staticRenderFns } from "./cnaas.vue?vue&type=template&id=1631826a&scoped=true"
import script from "./cnaas.vue?vue&type=script&lang=js"
export * from "./cnaas.vue?vue&type=script&lang=js"
import style0 from "./cnaas.vue?vue&type=style&index=0&id=1631826a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1631826a",
  null
  
)

export default component.exports